<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />

    <v-layout wrap text-left pb-2>
      <v-flex xs12>
        <span style="font-family: poppinssemibold; font-size: 22px" class="clr">
          Notify Me List
        </span>
      </v-flex>
    </v-layout>
    <v-layout wrap style="font-family: poppinssemibold">
      <v-flex xs12>
        <v-card>
          <v-layout wrap text-left>
            <v-flex xs12 sm2 pt-2 pa-1>
              <img
                style="object-fit: contain; cursor: pointer"
                :src="mediaURL + productData.productPhoto"
                height="160px"
                width="160px"
                contain
              />
            </v-flex>

            <v-flex sm10 pt-1>
              <v-layout wrap fill-height>
                <v-flex xs12 md6 align-self-center>
                  <v-layout wrap>
                    <v-flex xs5>
                      <b>Product Name </b>
                    </v-flex>
                    <v-flex xs7>
                      {{ productData.varientName }}
                    </v-flex>
                    <v-flex xs5>
                      <b>Price (₹) </b>
                    </v-flex>
                    <v-flex xs7>
                      {{ productData.price }}
                    </v-flex>
                    <v-flex xs5>
                      <b>Discount</b>
                    </v-flex>
                    <v-flex xs7> {{ productData.discount }} % </v-flex>
                    <v-flex xs5>
                      <b>Quantity </b>
                    </v-flex>
                    <v-flex xs7>
                      {{ productData.quantity }} {{ productData.quantityType }}
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 md6 align-self-center>
                  <v-layout wrap>
                    <v-flex xs5>
                      <b>Min Order Quantity :</b>
                    </v-flex>
                    <v-flex xs7>
                      {{ productData.minimumOrderQuantity }}
                    </v-flex>
                    <v-flex xs5>
                      <b>Max Order Quantity :</b>
                    </v-flex>
                    <v-flex xs7>
                      {{ productData.maxOrderQuantity }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap text-left pb-2 style="font-family: poppinsregular">
      <v-flex xs12 pt-2>
        <v-card>
          <template>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Date</th>
                    <th class="text-left">Customer Name</th>
                    <th class="text-left">Phone Number</th>
                    <th class="text-left">E-mail</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in userList" :key="item.name">
                    <td>{{ item.create_date.slice(0, 10) }}</td>
                    <td>
                      {{ item.userId.customerid.firstName }}&nbsp;
                      {{ item.userId.customerid.firstName }}
                    </td>
                    <td>{{ item.userId.phone }}</td>
                    <td>{{ item.userId.customerid.email }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
          
          </v-card >
        </v-flex >
      </v-layout>
     
      <v-layout wrap >
       <v-flex xs12>
        <v-pagination v-model="currentPage" :length="totalLength" total-visible="10" >
        </v-pagination>
       </v-flex>
     </v-layout>

    <!-- //         </v-card>
//       </v-flex>
//     </v-layout >
//      <v-layout wrap >
//       <v-flex xs12>
//        <v-pagination v-model="currentPage" :length="totalLength" total-visible="10" >
//        </v-pagination>
//       </v-flex>
//     </v-layout>
//   </div>
// </template> -->
  </div>
</template>


<script>
import axios from "axios";
export default {
  data() {
    return {
      userList: [],
      productData: {},
      appLoading: false,
      currentPage: 1,
      totalLength: 0,
      ServerError: false,
    };
  },

  mounted() {
    this.getData();
  },

  watch: {
    currentPage() {
      this.getData();
    },
  },

  methods: {
    getData() {
      // this.productList = [];
      this.appLoading = true;

      axios({
        url: "/grocery/admin/viewall/notify/list",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          productId: this.$route.query.productId,
          page: this.currentPage,
          limit: 50,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.productData = response.data.product;
            this.userList = response.data.data;
            this.totalLength = Math.ceil(response.data.totalLength / 50);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>